/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function LowInterpretation(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 9 9" className={props.className}>
      <path
        d="M4.50002 9C4.35345 9 4.20752 8.945 4.08859 8.83427L0.231374 5.26259C-0.0412022 5.01043 -0.0784886 4.55968 0.149087 4.2568C0.37602 3.95392 0.781028 3.9132 1.05425 4.16537L4.5071 7.36274L7.95416 4.28038C8.2306 4.03321 8.6356 4.08179 8.85804 4.38895C9.08047 4.69612 9.03675 5.14544 8.76032 5.39331L4.9031 8.84213C4.78546 8.94714 4.64274 9 4.50002 9Z"
        fill="#F62121"
      />
      <path
        d="M4.50002 5C4.35345 5 4.20752 4.945 4.08859 4.83427L0.231374 1.26259C-0.0412022 1.01043 -0.0784886 0.55968 0.149087 0.256801C0.37602 -0.0460779 0.781028 -0.0867951 1.05425 0.165366L4.5071 3.36274L7.95416 0.280375C8.2306 0.0332149 8.6356 0.0817899 8.85804 0.388955C9.08047 0.69612 9.03675 1.14544 8.76032 1.39331L4.9031 4.84213C4.78546 4.94714 4.64274 5 4.50002 5Z"
        fill="#F62121"
      />
    </SvgIcon>
  );
}
